import type { BlobLike } from "@pdfking/compatibility"
import type { Pixel, Rectangle, SpatialRectangle } from "@pdfking/math"
import type { Sequence } from "@pdfking/tfunc"
import type { PDFReaderOptions } from "./PDFReaderOptions"

export type PDFSplitResult = {
  blob: BlobLike
  media_box: SpatialRectangle<Pixel>
  trim_box: SpatialRectangle<Pixel>
  size: Rectangle<Pixel>
}

export type PDFSplitFunction = (
  input: PDFReaderOptions,
  rangeFn?: (page_count: number) => Sequence<number>
) => AsyncGenerator<PDFSplitResult>
